import React, { FC } from 'react'

import DefaultLayout, { DefaultLayoutProps } from '../../layouts/DefaultLayout'
import { BannerProps } from '../../components/Banner'
import { ActionButtonProps } from '../../components/ActionButton'

import * as SC from './styled'

export type AccountTemplateProps = {
  className?: string
  layout?: DefaultLayoutProps
  banner: BannerProps
  identity: {
    title: string
    civility?: string
    lastName: string
    firstName: string
  }
  job: {
    title: string
    function: string
  }
  email: {
    title: string
    email: string
  }
  modify: ActionButtonProps
  disconnect: ActionButtonProps
  declarations?: ActionButtonProps
}

const AccountTemplate: FC<AccountTemplateProps> = (props) => {
  const { layout, banner, identity, job, email, modify, disconnect, declarations } = props

  return (
    <DefaultLayout {...layout}>
      <SC.Content>
        <SC.Banner {...banner} />
        <SC.Wrapper>
          <SC.Block>
            <SC.UnderlineTitle text={identity.title} />
            <SC.Identity>
              {identity.civility && <SC.MarkdownText text={identity.civility} />}
              <SC.MarkdownText text={identity.lastName} />
              <SC.MarkdownText text={identity.firstName} />
            </SC.Identity>
          </SC.Block>
          <SC.Block>
            <SC.UnderlineTitle text={job.title} />
            <SC.MarkdownText text={job.function} />
          </SC.Block>
          <SC.Block>
            <SC.UnderlineTitle text={email.title} />
            <SC.MarkdownText text={email.email} />
          </SC.Block>
          <SC.Actions>
            {declarations && <SC.Button {...declarations} />}
            <SC.Button {...modify} />
            <SC.Button {...disconnect} />
          </SC.Actions>
        </SC.Wrapper>
      </SC.Content>
    </DefaultLayout>
  )
}

export default AccountTemplate
